import { Badge } from '@/components/ui/badge';
import {
  StatusServerlessTask,
  StatusServerlessTaskLabel,
  TypeServerless,
  TypeServerlessLabel,
} from '@/service/serverless-gpu/type';
import { shortEnglishHumanizer } from '@/utils/formatTime';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { columnsServerlessTask } from './type';
import BadgeTaskStatus from '../../components/BadgeTaskStatus';
import { fCurrencyUSD, fCurrencyUSDExtended } from '@/utils/formatNumber';

export const columns = ({
  isShowProjectId,
  isShowCost = false,
}: {
  isShowProjectId?: boolean;
  isShowCost?: boolean;
}): ColumnDef<columnsServerlessTask>[] => {
  const baseColumns: ColumnDef<columnsServerlessTask>[] = [
    {
      accessorKey: 'id',
      header: 'ID',
      cell: ({ row }) => {
        return (
          <div className="">
            <p>{row.getValue('id')}</p>
            <p className="text-xs text-muted-foreground">
              <span className="font-medium">
                {TypeServerlessLabel[row.original?.type as TypeServerless]}
              </span>
              {row.original?.name && ' · ' + row.original?.name}
            </p>
          </div>
        );
      },
    },

    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => {
        return (
          <BadgeTaskStatus
            status={row.getValue('status') as StatusServerlessTask}
          />
        );
      },
      size: 100,
    },
    {
      accessorKey: 'created_at',
      header: 'Created Date',
      cell: ({ row }) => {
        return (
          <span>
            {dayjs(row.getValue('created_at')).format('DD MMM YYYY, HH:mm')}
          </span>
        );
      },
      size: 110,
    },
  ];

  if (isShowCost) {
    baseColumns.push({
      accessorKey: 'amount',
      header: 'Amount',
      cell: ({ row }) => {
        return <span>{fCurrencyUSDExtended(row.getValue('amount') || 0)}</span>;
      },
      size: 60,
    });
  }

  if (isShowProjectId) {
    baseColumns.push({
      accessorKey: 'project_id',
      header: 'Project ID',
      cell: ({ row }) => {
        return (
          <span className="text-xs text-muted-foreground">
            {row.getValue('project_id')}
          </span>
        );
      },
      size: 100,
    });
  }

  

  return baseColumns;
};
